import { z } from "zod";

/**
 * Wire formats shared by the Twilio payload schema and the authoring rules.
 * They live alone so the editor can check them as the author types without
 * importing the payload schema, whose module graph the app must not take on.
 */

export const E164_PATTERN = String.raw`\+[1-9]\d{1,14}`;

export function isE164(value: string): boolean {
  return new RegExp(`^${E164_PATTERN}$`).test(value);
}

/**
 * Twilio permits a variable only at the *end* of a URL, after a fixed domain.
 * Anything earlier is rejected, so a compiled URL is either fully literal or
 * literal-prefix-then-one-trailing-variable.
 */
export const urlWithOptionalTrailingVariable = z
  .string()
  .refine((url) => url.includes("{{") || URL.canParse(url), {
    message: "must be a URL",
  })
  .refine(
    (url) =>
      !url.includes("{{") ||
      /^https?:\/\/[^/{]+\/[^{}]*\{\{[^{}]+\}\}$/.test(url),
    {
      message:
        "a URL variable must be the trailing segment, after a fixed domain and path",
    },
  );
